<template>
  <div>
    <div @click="close()" class="fixed inset-0 z-50 bg-gray-900 bg-opacity-70 w-screen h-screen"></div>

    <div
      id="cashbackHowItWorksContainer"
      class="transition-all duration-300 translate-x-full rtl:ease-in ease-in-out fixed flex flex-col items-center lg:items-end ltr:right-0 rtl:left-0 top-0 z-50 overflow-x-hidden overflow-y-auto lg:overflow-hidden h-full w-full lg:w-auto"
    >
      <div class="w-full max-w-[97%] text-right lg:hidden">
        <button @click="close()" class="bg-white rounded-full h-10 w-10 appearance-none flex-shrink-0 mt-2 p-0">
          <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
          <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
        </button>
      </div>

      <div
        class="bg-blue rounded-lg py-10 px-6 w-full max-w-[97%] mt-4 mb-20 lg:rounded-none ltr:lg:rounded-tl-lg ltr:lg:rounded-bl-lg rtl:lg:rounded-tr-lg rtl:lg:rounded-br-lg lg:min-w-[480px] lg:max-w-[605px] lg:mt-0 lg:mb-0 lg:h-full lg:pl-[75px] lg:pr-[100px] lg:py-14 lg:overflow-y-auto flex flex-col"
      >
        <button @click="close()" class="hidden lg:block bg-white rounded-full h-10 w-10 appearance-none flex-shrink-0 p-0 mb-8">
          <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
          <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
        </button>

        <div class="flex justify-start mb-8">
          <img src="@/assets/img/cashback/how-it-works-slider.svg" :alt="$t('cashback_how_it_works').tTitle()" class="w-[186px] h-[170px]" />
        </div>

        <h2 class="font-display text-[28px] leading-[48px] font-bold text-white mb-8 lg:mb-10">{{ $t('cashback_how_it_works').tTitle() }}</h2>

        <div v-for="(step, index) in steps" :key="index" class="mb-10 lg:mb-12 last:mb-0">
          <p class="text-gold font-body text-sm mb-1">{{ step.label }}</p>
          <p class="text-white font-body font-semibold text-[20px] mb-1">{{ step.title }}</p>
          <p class="text-white font-body text-base">{{ step.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    steps() {
      return [
        {
          label: this.$t('cashback_step_01'),
          title: this.$t('cashback_step_1_title').tTitle(),
          description: this.$t('cashback_step_1_description'),
        },
        {
          label: this.$t('cashback_step_02'),
          title: this.$t('cashback_step_2_title').tTitle(),
          description: this.$t('cashback_step_2_description'),
        },
        {
          label: this.$t('cashback_step_03'),
          title: this.$t('cashback_step_3_title').tTitle(),
          description: this.$t('cashback_step_3_description'),
        },
        {
          label: this.$t('cashback_step_04'),
          title: this.$t('cashback_step_4_title').tTitle(),
          description: this.$t('cashback_step_4_description'),
        },
      ]
    },
  },
  mounted() {
    document.querySelector('body').classList.add('overflow-hidden')
    this.$nextTick(() => {
      setTimeout(() => {
        document.getElementById('cashbackHowItWorksContainer').classList.remove('translate-x-full')
      }, 10)
    })
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove('overflow-hidden')
  },
  methods: {
    close() {
      const container = document.getElementById('cashbackHowItWorksContainer')
      if (container) container.classList.add('translate-x-full')
      document.querySelector('body').classList.remove('overflow-hidden')
      setTimeout(() => this.$emit('close'), 300)
    },
  },
}
</script>

<style>
#cashbackHowItWorksContainer::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

#cashbackHowItWorksContainer::-webkit-scrollbar-track {
  background: #2b63e3;
  border-radius: 12px;
}

#cashbackHowItWorksContainer::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 12px;
}
</style>
